import { ErrorBoundary } from '@sentry/react';
import { Translate } from 'i18n';
import React, { FC } from 'react';
import styled from 'styled-components';

const SError = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 20px;
  background: rgb(var(--ln-overlay) / 0.1);
  color: rgb(var(--ln-content));
  font-size: 14px;
`;

// withErrorBoundary covers the whole viewport and opens the Sentry dialog; a block
// that fails inside a working page must replace itself and nothing else.
export function withInlineErrorBoundary<P extends object>(
  WrappedComponent: React.ComponentType<P>
): FC<P> {
  const hocComponent: FC<P> = (props) => (
    <ErrorBoundary
      fallback={
        <SError role="alert">
          <Translate str="frontend.incompatible_page.something_went_wrong" />
        </SError>
      }
    >
      <WrappedComponent {...props} />
    </ErrorBoundary>
  );
  hocComponent.displayName = `withInlineErrorBoundary(${
    WrappedComponent.displayName ?? WrappedComponent.name ?? 'Component'
  })`;

  return hocComponent;
}
